// Banner messages can embed times as {{datetime:ISO}} or {{time:ISO}}, e.g.
// "Maintenance on {{datetime:2026-10-23T21:00:00Z}} until {{time:2026-10-23T21:15:00Z}}".
// They are shown in the user's own locale and time zone.
const TOKEN_PATTERN = /\{\{(datetime|time):([^}]+)\}\}/g

const FORMATS = {
	datetime: {
		weekday: "short",
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
		timeZoneName: "short",
	},
	time: { hour: "numeric", minute: "2-digit", timeZoneName: "short" },
}

export function formatBannerMessage(message, locale, timeZone) {
	if (!message) return message

	return message.replace(TOKEN_PATTERN, (token, kind, iso) => {
		const date = new Date(iso.trim())
		if (Number.isNaN(date.getTime())) return token

		try {
			return new Intl.DateTimeFormat(locale, {
				...FORMATS[kind],
				timeZone,
			}).format(date)
		} catch {
			return date.toUTCString()
		}
	})
}
